export const FAQS = [
  {
    q: "What does IT-Patrol do?",
    a: "IT-Patrol designs and builds ecommerce platforms, SaaS products, and production-ready AI systems for teams that need senior-owned delivery — not slide decks.",
  },
  {
    q: "What are IT-Patrol’s main services?",
    a: "Ecommerce (Shopify themes, apps, custom storefronts), SaaS (multi-tenant products, APIs, billing), and AI (agents, RAG, evals, operable LLM workflows).",
  },
  {
    q: "How does IT-Patrol work with existing stacks?",
    a: "We work underneath your stack — not instead of it. We harden and extend DMS, CRM, commerce platforms, and internal tools while keeping systems maintainable.",
  },
  {
    q: "How do I start a project?",
    a: "Use the contact form with the problem, desired outcome, current stack, and timing. We reply with a clear next step — usually within a few business days.",
  },
  {
    q: "Which Shopify apps does IT-Patrol publish?",
    a: "Cart Reservation Patrol (inventory holds and cart timers), AI Sales and Conversion Patrol (conversational shopping), and EU Compliance Patrol (withdrawals, guarantees, GARAN labels, and AI Act Art. 50 transparency).",
  },
  {
    q: "Where is IT-Patrol based?",
    a: "IT-Patrol is based in Sfax, Tunisia, and works with merchants and product teams worldwide.",
  },
];
